// Module
var code = "<div class=\"widget-content relative\"> <leaflet id=\"{{ vm.id }}\" lf-center=\"vm.center\" event-broadcast=\"vm.events\" markers=\"vm.markers\" width=\"100%\" defaults=\"vm.defaults\" height=\"100%\"/> </div> ";
// Exports
module.exports = code;